module.exports = __webpack_public_path__ + "img/g_vie.516023af.png";